import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67325d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-shrink-0 p-3 bg-white menu",
  style: {"width":"280px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center pb-3 mb-3 link-dark text-decoration-none border-bottom" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-semibold" }, "Cart Admin")
], -1))
const _hoisted_3 = { class: "list-unstyled flex-column mb-auto ps-0" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-toggle align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#home-collapse",
  "aria-expanded": "true"
}, " Submissions ", -1))
const _hoisted_6 = {
  class: "collapse show",
  id: "home-collapse"
}
const _hoisted_7 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Orders")
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Quote Requests")
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-toggle align-items-center rounded collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#dashboard-collapse",
  "aria-expanded": "false"
}, " Customer Service ", -1))
const _hoisted_14 = {
  class: "collapse",
  id: "dashboard-collapse"
}
const _hoisted_15 = { class: "btn-toggle-nav list-unstyled fw-normal pb-1 small" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Customer Impersonation")
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Admin Order Submit")
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("User Management")
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Load Cart")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = { class: "list-unstyled" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b-divider" }, null, -1))
const _hoisted_30 = { class: "p-5 view-area" }

import { ref, onMounted } from 'vue'
import { useAuthService } from '@/services/auth-service'
import { useAppStore } from '@/stores/app'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminViewComponent',
  setup(__props) {

const appStore = useAppStore()
const authService = useAuthService()
const router = useRouter()
const authStore = useAuthStore()

const isAuth = ref<boolean>(false)

async function logout() {
    appStore.loadingWhile(async () => {
        await authService.logout()
        router.push('login')
    })
}

onMounted(async () => {
  isAuth.value = await authService.isAuth()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_unref(authStore).getIsAuth())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: "/admin/orders",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: "/admin/quote-requests",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: "/admin/customer-impersonation",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        to: "/admin/submit",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: "/admin/user-management",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _createVNode(_component_router_link, {
                        to: "/admin/load-cart",
                        class: "link-dark rounded"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _hoisted_24,
      _createElementVNode("ul", _hoisted_25, [
        (isAuth.value)
          ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (logout())),
                href: "javascript:void 0;",
                class: "link-dark rounded"
              }, "Logout")
            ]))
          : (_openBlock(), _createElementBlock("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                to: "/admin/login",
                class: "link-dark rounded"
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})